module.exports = __webpack_public_path__ + "static/images/raceitem2.f3fb6f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/race/raceitem2.jpg
// module id = ElVu
// module chunks = 1